import { useNavigation } from 'react-router-dom';

export const usePendingPath = (): string | null => {
  const navigation = useNavigation();
  return navigation.state === 'loading' ? (navigation.location?.pathname ?? null) : null;
};
